<template>
  <div class="app">
    <div class="icons">
      <button class="icon" @click="edit">編集</button>
      <button class="icon" @click="doblecheck">
        削除
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase"
import { minpuroproducts } from "../../../firebase.config"
export default {
  data() {
    return {
      creatorName: "",
      productName: "",
    }
  },
  methods: {
    edit() {
      this.$router.push({ path: `/edit/${this.productId}` })
    },
    Logout() {
      firebase.auth().signOut()
    },
    doblecheck() {
      const message = "本当に削除しますか？この操作は取り消せません。"
      if (window.confirm(message)) {
        minpuroproducts
          .doc(this.productId)
          .get()
          .then((snapshot) => {
            this.creatorName = snapshot.data().creatorName
            this.productName = snapshot.data().productName
          })
          .then(() => {
            minpuroproducts
              .doc(this.productId)
              .delete()
              .then(() => {
                const storageRef = firebase.storage().ref()
                const FileName = this.creatorName + "_" + this.productName
                const fileRef = storageRef.child("images/" + FileName)
                fileRef.delete()
              })
              .then(() => {
                alert("削除しました。")
                this.$router.push("/")
              })
              .catch((error) => {
                console.error("Error removing document: ", error)
              })
          })

        //
      }
    },
  },
  computed: {
    productId() {
      return this.$route.params.id
    },
  },
}
</script>

<style lang="scss" scoped>
.icons {
  margin: 10px 0px;
  float: right;
  display: flex;
  justify-content: flex-end;
  align-content: flex-end;

  .icon {
    width: 5rem;
    height: 3rem;
    margin: 0px 0.7rem;
    border-radius: 1rem;
    background: transparent linear-gradient(180deg, #ffac59 0%, #ffca59 100%);
    border: solid 1px #854200;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 5px #683e00;
    outline: none;
    transition: all 150ms 0s ease;
  }
  .icon:hover {
    box-shadow: none;
    transform: translateY(5px);
  }
  .icon:focus {
    background: transparent linear-gradient(180deg, #a16c36 0%, #ac883a 100%);
  }
}
</style>
